<div class="calendar-container">
    <div class="calendar-header row align-items-center justify-content-between">
        <div class="col-md-4 col-12 order-2 order-lg-1">
            <div class="actions-container d-flex align-items-center justify-content-center">
                <div class="col-10 d-flex justify-content-start align-items-center">
                    <i class="hgi hgi-stroke hgi-calendar-03 icon-grey"></i>
                    <span class="ml-1 title">{{ title }}</span>
                </div>
                <div class="col-2 d-flex justify-content-end">
                    <button (click)="backData()" class="btn p-0">
                        <i class="hgi hgi-stroke hgi-arrow-left-01 icon-grey"></i>
                    </button>
                    <button (click)="nextData()" class="btn p-0">
                        <i class="hgi hgi-stroke hgi-arrow-right-01 icon-grey"></i>
                    </button>
                </div>
            </div>
        </div>

        <div class="view-contianer col-md-4 col-12 order-1 order-lg-2 d-flex justify-content-center">
            <div class="alter-view">
                <button [ngClass]="{ 'view-active': viewOption == 'dia' }" (click)="alterView('dia')"
                    class="btn btn-view">
                    Dia
                </button>
                <button [ngClass]="{ 'view-active': viewOption == 'semana' }" (click)="alterView('semana')"
                    class="btn btn-view">
                    Semana
                </button>
                <button [ngClass]="{ 'view-active': viewOption == 'mes' }" (click)="alterView('mes')"
                    class="btn btn-view">
                    Mês
                </button>
            </div>
        </div>

        <div class="col-md-4 col-12 order-3 order-lg-3 d-flex justify-content-end" *ngIf="gerenciarHorarios">
            <button class="btn primary-white-button d-flex align-items-center btn-add-event" (click)="createEvento()">
                Adicionar Evento
                <i class="hgi hgi-stroke hgi-add-circle ml-2"></i>
            </button>
        </div>
    </div>
    <div [ngClass]="currentCalendarView">
        <full-calendar #calendar [options]="calendarOptions"></full-calendar>
    </div>
</div>